import Emitter from "./Emitter";

export default class OutOfMoney extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({ event: "insufficientFundsError" });
    }

    SPINGAMES_handler() {
        this.emitTop({ error:0, message: 'Not enuf chips!'});
        this.emitParent({ error:0, message: 'Not enuf chips!'});
    }

    BWIN_handler() {
        this.emitParent("out_of_credits")
        this.emitTop("out_of_credits")
    }


    PLAYTECH_handler() {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('displaystatus')) {
            const dataTwo = {
                "_type": "ucip.displaystatus.g2wUiStateNotification",
                "busy": true
            }

            if (this.gb.settings.nativeMobileApp) {
                dataTwo.handled = true;
                window.parent.postMessage(JSON.stringify(dataTwo));
                
            } else {
                this.emitParent(JSON.stringify(dataTwo));
            }
        }
    }

    _default() {
        this.emitTop({ wpgaction: "errorOutOfMoney" });
        this.emitParent({ wpgaction: "errorOutOfMoney.parent" });
    }
}
